export enum OrderStatus {
  AllOrders = 'All Orders',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  Created = 'Created',
  InProgress = 'InProgress',
  Pending = 'Pending',
  Expired = 'Expired',
  Declined = 'Declined',
  Closed = 'Closed',
}
